export enum SelectedElement {
  BlankSpace = 'BlankSpace',
  DealFreezeBanner = 'freezeBanner', // Added as a part of c747927f-deal-freeze-srp
  ReviewRating = 'ReviewRating',
  Location = 'Location',
  ShowAllDeals = 'ShowAllDeals',
  Image = 'Image',
  Price = 'Price',
  StarRating = 'StarRating',
  HotelName = 'HotelName'
}
